module.exports = __webpack_public_path__ + "static/media/one_pen.172bab91.svg";